import { render, staticRenderFns } from "./selectRegion.vue?vue&type=template&id=7d57d45e&scoped=true&"
import script from "./selectRegion.vue?vue&type=script&lang=js&"
export * from "./selectRegion.vue?vue&type=script&lang=js&"
import style0 from "./selectRegion.vue?vue&type=style&index=0&id=7d57d45e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d57d45e",
  null
  
)

export default component.exports